import type { TemplateFormsState } from '../index';
import type { LayoutType } from 'types';
import { findTemplateSectionIndex, uniquifySectionNameOnTab } from '../utils/nameUniqueness';

interface Payload {
  layoutType: LayoutType;
  sectionName: string;
  targetTab: string | null;
  targetIndex: number;
  sourceTab?: string | null;
}

export const moveSectionToTab = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { layoutType, sectionName, targetTab, targetIndex, sourceTab } = payload;
  const sections = state[layoutType].sections;
  const tabs = state[layoutType].tabs;

  if (targetTab !== null && !tabs.some((t) => t.id === targetTab)) return;

  const sourceIndex = findTemplateSectionIndex(sections, sectionName, sourceTab);
  if (sourceIndex === -1) return;

  const existingNames = new Set(
    sections.filter((_, index) => index !== sourceIndex && (sections[index].tabId ?? null) === targetTab).map((section) => section.name)
  );

  const [moved] = sections.splice(sourceIndex, 1);
  uniquifySectionNameOnTab(moved, existingNames);
  moved.tabId = targetTab;

  // Adjust targetIndex: after splicing the source, indices after sourceIndex shift down by 1.
  const adjustedTargetIndex = sourceIndex < targetIndex ? targetIndex - 1 : targetIndex;
  const insertIndex = Math.max(0, Math.min(adjustedTargetIndex, sections.length));
  sections.splice(insertIndex, 0, moved);
  sections.forEach((section, index) => {
    section.order = index;
  });
};
